import React, { Component } from 'react';
import golbeldata from '../data.json';
import Appnav from './Appnav.js'
import AppFooter from './Footer.js'
import AppTopHeader from './AppTopHeader.js'
import { Link, Route, Switch } from 'react-router-dom';

class Home extends Component {
    constructor(props) {
        super(props);

        this.concerts = golbeldata;
    }

    componentDidMount() {
        document.title = this.concerts.HotelName+" Home";
        if (window.jQuery().revolution) {
            window.jQuery('.banner').revolution({
                delay: 9000,
                startwidth: 1170,
                startheight: 449,
                autoHeight:"off",
                fullScreenAlignForce:"off",
                
                onHoverStop: "on",
    
                thumbWidth: 100,
                thumbHeight: 50,
                thumbAmount: 3,
    
                hideThumbsOnMobile: "on",
                hideBulletsOnMobile: "on",
                hideArrowsOnMobile: "on",
                hideThumbsUnderResoluition: 0,
                
                hideThumbs:0,
                hideTimerBar:"on",
    
                keyboardNavigation:"on",
                
                navigationType: "none",
                navigationArrows: "solo",
                navigationStyle: "round",
    
                navigationHAlign: "center",
                navigationVAlign: "bottom",
                navigationHOffset: 30,
                navigationVOffset: 30,
    
                soloArrowLeftHalign: "left",
                soloArrowLeftValign: "center",
                soloArrowLeftHOffset: 20,
                soloArrowLeftVOffset: 0,
    
                soloArrowRightHalign: "right",
                soloArrowRightValign: "center",
                soloArrowRightHOffset: 20,
                soloArrowRightVOffset: 0,
    
                touchenabled: "on",
                swipe_velocity:"0.7",
                swipe_max_touches:"1",
                swipe_min_touches:"1",
                drag_block_vertical:"false",
    
                stopAtSlide: -1,
                stopAfterLoops: -1,
                hideCaptionAtLimit: 0,
                hideAllCaptionAtLilmit: 0,
                hideSliderAtLimit: 0,
    
                dottedOverlay: "none",
    
                fullWidth:"off",
                forceFullWidth:"off",
                fullScreen: "off",
                fullScreenOffsetContainer: "#topheader-to-offset",
    
                shadow: 0
    
            });
        }  

        if (window.jQuery().owlCarousel) {
            window.jQuery("#owl-gallery").owlCarousel({
                autoPlay: 3000,
                //Set AutoPlay to 3 seconds
                items: 3,
                itemsDesktop: [1199, 3],
                itemsDesktopSmall: [979, 3],
                pagination: false
            });
        }

        if (window.jQuery().prettyPhoto) {
            window.jQuery('a[data-rel]').each(function () {
                window.jQuery(this).attr('rel',  window.jQuery(this).data('rel'));
            });
    
            window.jQuery("a[rel^='prettyPhoto']").prettyPhoto({
                social_tools: false,
                animation_speed: 'normal', // fast/slow/normal 
                slideshow: 5000, // false OR interval time in ms
                autoplay_slideshow: false, // true/false
                opacity: 0.80, // Value between 0 and 1 
                show_title: true, // true/false            
                allow_resize: true, // Resize the photos bigger than viewport. true/false
                default_width: 500,
                default_height: 344,
                counter_separator_label: '/', // The separator for the gallery counter 1 "of" 2
                theme: 'pp_default', // light_rounded / dark_rounded / light_square / dark_square / facebook
                horizontal_padding: 20, // The padding on each side of the picture 
                hideflash: false, // Hides all the flash object on a page, set to TRUE if flash appears over prettyPhoto
                wmode: 'opaque', // Set the flash wmode attribute
                autoplay: true, // Automatically start videos: True/False 
                modal: false, // If set to true, only the close button will close the window
                deeplinking: true, // Allow prettyPhoto to update the url to enable deeplinking. 
                overlay_gallery: true, // If set to true, a gallery will overlay the fullscreen image on mouse over 
                keyboard_shortcuts: true, // Set to false if you open forms inside prettyPhoto 
                changepicturecallback: function () {}, // Called everytime an item is shown/changed 
                callback: function () {}, // Called when prettyPhoto is closed
            });
        }  

        window.$('#parallax-pagetitle').parallax("50%", -0.55);
    }

    render() {        
        return (
            <div>
                <AppTopHeader data={this.concerts}/>
                <header>
                    <Appnav data={this.concerts} />
                </header>
                <section class="revolution-slider">
                    <div class="bannercontainer">
                        <div class="banner">
                            <ul>
                                <li data-transition="fade" data-slotamount="7" data-masterspeed="1500" >
                                    <img src={'images/slides/' + this.concerts.SliderImages[0].Path} style={{ opacity: "0" }} alt="slidebg1" data-bgfit="cover" data-bgposition="left bottom" data-bgrepeat="no-repeat" />
                                </li>
                                <li data-transition="boxfade" data-slotamount="7" data-masterspeed="1000" >
                                    <img src={'images/slides/' + this.concerts.SliderImages[1].Path} alt="darkblurbg" data-bgfit="cover" data-bgposition="left top" data-bgrepeat="no-repeat" />
                                </li>
                            </ul>
                        </div>
                    </div>
                </section>


                <section id="reservation-form">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-12">
                                <form class="form-inline reservation-horizontal clearfix" role="form" method="post" action="php/reservation.php" name="reservationform" id="reservationform">
                                    <div id="message"></div>
                                    <div class="row">
                                        <div class="col-sm-3">
                                            <div class="form-group">
                                                <label for="email" accesskey="E">E-mail</label>
                                                <input name="email" type="text" id="email" value="" class="form-control" placeholder="Please enter your E-mail" />
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <div class="form-group">
                                                <label for="room">Room Type</label>
                                                <div class="popover-icon" data-container="body" data-toggle="popover" data-trigger="hover" data-placement="right" data-content="Vivamus sagittis lacus vel augue laoreet rutrum faucibus."> <i class="fa fa-info-circle fa-lg"> </i> </div>
                                                <select class="form-control" name="room" id="room">
                                                    <option selected="selected" disabled="disabled">Select a room</option>
                                                    <option value="Single">Single room</option>
                                                    <option value="Double">Double Room</option>
                                                    <option value="Deluxe">Deluxe room</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <div class="form-group">
                                                <label for="checkin">Check-in</label>
                                                <div class="popover-icon" data-container="body" data-toggle="popover" data-trigger="hover" data-placement="right" data-content="Check-In is from 11:00"> <i class="fa fa-info-circle fa-lg"> </i> </div>
                                                <i class="fa fa-calendar infield"></i>
                                                <input name="checkin" type="text" id="checkin" value="" class="form-control" placeholder="Check-in" />
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <div class="form-group">
                                                <label for="checkout">Check-out</label>
                                                <div class="popover-icon" data-container="body" data-toggle="popover" data-trigger="hover" data-placement="right" data-content="Check-out is from 12:00"> <i class="fa fa-info-circle fa-lg"> </i> </div>
                                                <i class="fa fa-calendar infield"></i>
                                                <input name="checkout" type="text" id="checkout" value="" class="form-control" placeholder="Check-out" />
                                            </div>
                                        </div>
                                        <div class="col-sm-1">
                                            <div class="form-group">
                                                <div class="guests-select">
                                                    <label>Guests</label>
                                                    <i class="fa fa-user infield"></i>
                                                    <div class="total form-control" id="test">1</div>
                                                    <div class="guests">
                                                        <div class="form-group adults">
                                                            <label for="adults">Adults</label>
                                                            <div class="popover-icon" data-container="body" data-toggle="popover" data-trigger="hover" data-placement="right" data-content="+18 years"> <i class="fa fa-info-circle fa-lg"> </i> </div>
                                                            <select name="adults" id="adults" class="form-control">
                                                                <option value="1">1 adult</option>
                                                                <option value="2">2 adults</option>
                                                                <option value="3">3 adults</option>
                                                            </select>
                                                        </div>
                                                        <div class="form-group children">
                                                            <label for="children">Children</label>
                                                            <div class="popover-icon" data-container="body" data-toggle="popover" data-trigger="hover" data-placement="right" data-content="0 till 18 years"> <i class="fa fa-info-circle fa-lg"> </i> </div>
                                                            <select name="children" id="children" class="form-control">
                                                                <option value="0">0 children</option>
                                                                <option value="1">1 child</option>
                                                                <option value="2">2 children</option>
                                                                <option value="3">3 children</option>
                                                            </select>
                                                        </div>
                                                        <button type="button" class="btn btn-default button-save btn-block">Save</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <button type="submit" id="btn1" class="btn btn-primary btn-block">Book Now</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </section>


                <section class="rooms mt50">
                    <div class="container">
                        <div class="row">
                            <div class="col-sm-12">
                                <h2 class="lined-heading"><span>Guests Favorite Rooms</span></h2>
                            </div>
                            {
                                this.concerts.Roomhome.map(function (item) {
                                    return <div class="col-sm-4">
                                        <div class="room-thumb"> <img src={'images/rooms/Thumblarge/' + item.Path} alt="room 1" class="img-responsive" />
                                            <div class="mask">
                                                <div class="main">
                                                    <h5>{item.heading}</h5>
                                                    <div class="price">{item.Price}</div>
                                                </div>
                                                <div class="content">
                                                    <p><span>{item.Title}</span> {item.Description}</p>
                                                    <div class="row">
                                                        <div class="col-xs-6">
                                                            <ul class="list-unstyled">
                                                                <li><i class="fa fa-check-circle"></i> Laundry</li>
                                                                <li><i class="fa fa-check-circle"></i> Bathroom</li>
                                                            </ul>
                                                        </div>
                                                        <div class="col-xs-6">
                                                            <ul class="list-unstyled">
                                                                <li><i class="fa fa-check-circle"></i> Free Wi-Fi</li>
                                                                <li><i class="fa fa-check-circle"></i> Incl. breakfast</li>

                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>;
                                })
                            }



                        </div>
                    </div>
                </section>


                <section class="usp mt100">
                    <div class="container">
                        <div class="row">
                            <div class="col-sm-12">
                                <h2 class="lined-heading"><span>USP section</span></h2>
                            </div>
                            <div class="col-sm-3 " data-start="0">
                                <div class="box-icon">
                                    <div class="circle"><i class="fa fa-glass fa-lg"></i></div>
                                    <h3>Banquet Hall</h3>
                                   
                                </div>
                            </div>
                            <div class="col-sm-3 " data-start="400">
                                <div class="box-icon">
                                    <div class="circle"><i class="fa fa-car fa-lg"></i></div>
                                    <h3>Parking</h3>
                                    
                                </div>
                            </div>
                            <div class="col-sm-3 " data-start="800">
                                <div class="box-icon">
                                    <div class="circle"><i class="fa fa-cutlery fa-lg"></i></div>
                                    <h3>Restaurant</h3>
                                    
                                </div>
                            </div>
                            <div class="col-sm-3 " data-start="1200">
                                <div class="box-icon">
                                    <div class="circle"><i class="fa fa-glass fa-lg"></i></div>
                                    <h3>Marriage Garden</h3>
                                   
                                </div>
                            </div>
                        </div>
                    </div>
                </section>



                <section class="parallax-effect mt100">
                    <div id="parallax-image" style={{ backgroundImage: 'url("images/parallax/' + this.concerts.parllex + '")' }}>
                        <div class="color-overlay fadeIn appear" data-start="600">
                            <div class="container">
                                <div class="content">
                                    <h3 class="text-center"><i class="fa fa fa-star-o"></i> {this.concerts.HotelName}</h3>

                                </div>
                            </div>
                        </div>
                    </div>
                </section>


                <section class="gallery-slider mt100">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-12">
                                <h2 class="lined-heading"><span>Gallery</span></h2>
                            </div>
                        </div>
                    </div>
                    <div id="owl-gallery" class="owl-carousel">
                        {
                            this.concerts.GalleryHomeImage.map(function (item) {
                                return <div class="item"><a href={'images/gallery/' + item.Path} data-rel="prettyPhoto[gallery1]"><img src={'images/gallery/' + item.Path} alt="Image 1" /><i class="fa fa-search"></i></a></div>;
                            })
                        }
                    </div>
                </section>
                <AppFooter data={this.concerts} />
                <div id="go-top"><i class="fa fa-angle-up fa-2x"></i></div>

            </div>
        )
    }
}
export default Home;


// WEBPACK FOOTER //
// ./src/components/Home.js